import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './About.css';

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <h1 className="about-hero-title">About Hiring Open</h1>
          <p className="about-hero-subtitle">
            Connecting talented professionals with leading employers worldwide
          </p>
        </div>
      </section>

      {/* Mission Section */}
      <section className="about-mission">
        <div className="container">
          <div className="mission-content">
            <div className="mission-text">
              <h2>Our Mission</h2>
              <p>
                At HiringOpen, we believe that finding the right job or the perfect candidate
                shouldn't be complicated. Our mission is to simplify the hiring process and
                empower both job seekers and employers with the tools they need to succeed.
              </p>
              <p>
                We're dedicated to creating meaningful connections that lead to successful
                careers and thriving businesses. Through innovative technology and personalized
                support, we're transforming the way people find opportunities.
              </p>
            </div>
            {/* <div className="mission-image">
              <div className="mission-placeholder">
                <span className="material-symbols-outlined mission-icon">target</span>
              </div>
            </div> */}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      {/* <section className="about-stats">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-number">10,000+</div>
              <div className="stat-label">Active Jobs</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">5,000+</div>
              <div className="stat-label">Companies</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">50,000+</div>
              <div className="stat-label">Job Seekers</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">15,000+</div>
              <div className="stat-label">Success Stories</div>
            </div>
          </div>
        </div>
      </section> */}

      {/* Values Section */}
      <section className="about-values">
        <div className="container">
          <h2 className="section-title">Our Core Values</h2>
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon"><span className="material-symbols-outlined">lightbulb</span></div>
              <h3>Innovation</h3>
              <p>We continuously evolve our platform with cutting-edge technology to provide the best experience.</p>
            </div>
            <div className="value-card">
              <div className="value-icon"><span className="material-symbols-outlined">handshake</span></div>
              <h3>Trust</h3>
              <p>We build lasting relationships based on transparency, integrity, and mutual respect.</p>
            </div>
            <div className="value-card">
              <div className="value-icon"><span className="material-symbols-outlined">stars</span></div>
              <h3>Excellence</h3>
              <p>We strive for excellence in everything we do, from our platform to our customer service.</p>
            </div>
            <div className="value-card">
              <div className="value-icon"><span className="material-symbols-outlined">public</span></div>
              <h3>Diversity</h3>
              <p>We celebrate diversity and create opportunities for everyone, regardless of background.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="about-team">
        <div className="container">
          <h2 className="section-title">Meet Our Team</h2>
          <p className="section-subtitle">Passionate professionals dedicated to your success</p>
          <div className="team-grid">
            <div className="team-member">
              <div className="member-avatar"><span className="material-symbols-outlined">person</span></div>
              <h3>John Smith</h3>
              <p className="member-role">CEO & Founder</p>
              <p className="member-bio">Visionary leader with 15+ years in tech recruitment</p>
            </div>
            <div className="team-member">
              <div className="member-avatar"><span className="material-symbols-outlined">person</span></div>
              <h3>Sarah Johnson</h3>
              <p className="member-role">CTO</p>
              <p className="member-bio">Tech innovator building scalable solutions</p>
            </div>
            <div className="team-member">
              <div className="member-avatar"><span className="material-symbols-outlined">person</span></div>
              <h3>Mike Chen</h3>
              <p className="member-role">Head of Design</p>
              <p className="member-bio">Creating beautiful, user-centric experiences</p>
            </div>
            <div className="team-member">
              <div className="member-avatar"><span className="material-symbols-outlined">person</span></div>
              <h3>Emily Davis</h3>
              <p className="member-role">Head of Operations</p>
              <p className="member-bio">Ensuring smooth operations and customer satisfaction</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="about-cta">
        <div className="container">
          <h2>Ready to Get Started?</h2>
          <p>Join thousands of professionals and companies on HiringOpen today</p>
          <div className="cta-buttons">
            <Link to="/register" className="btn btn-primary btn-lg">
              Create Account
            </Link>
            <Link to="/jobs" className="btn btn-secondary btn-lg">
              Browse Jobs
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
